import React from 'react';
import { Drawer, Box } from '@mui/material';

type Props = {
  open: boolean;
  onClose: () => void;
  width?: number;
  topOffset?: number;
  children?: React.ReactNode;
};

export const KendoAIChatAssitant = ({
  open,
  onClose,
  width = 420,
  topOffset = 24,
  children,
}: Props) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      PaperProps={{
        style: {
          position: 'fixed',
          top: topOffset,
          height: `calc(100% - ${topOffset}px)`,
          width,
          boxSizing: 'border-box',
        },
      }}
    >
      <Box sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ flex: 1, overflow: 'auto' }}>
          {children ?? <div>AI Grid content goes here.</div>}
        </Box>
      </Box>
    </Drawer>
  );
};

export default KendoAIChatAssitant;
